import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, MessageCircleIcon, ShieldAlertIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/inmwEJ7JJ3r3xYt1tpWV3E/WhatsApp_Image_2026-04-17_at_15.16.46.jpg';
const CONFIG = {
  videoUrl: 'https://player.vimeo.com/video/1185864020?title=0&byline=0&portrait=0&badge=0&autopause=0'
};
const whatsappLink = 'https://wa.me/5493364322501?text=Hola,%20quiero%20acceder,%20o%20ya%20accedí%20al%20bot';
export function App() {
  return <div className="min-h-screen bg-navy text-white font-sans" data-id="element-0">
      {/* Background glow */}
      <div className="fixed inset-0 pointer-events-none" data-id="element-1">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-primary/15 rounded-full blur-[150px]" data-id="element-2" />
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[300px] h-[300px] bg-secondary/10 rounded-full blur-[120px]" data-id="element-3" />
      </div>

      <main className="relative z-10 max-w-2xl mx-auto px-4 sm:px-6 py-16 sm:py-24" data-id="element-4">
        {/* Hero — Logo + Headline */}
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-5">
          <img src={LOGO_URL} alt="InnovaTrading Logo" className="w-40 sm:w-52 rounded-2xl mx-auto mb-6 border border-white/10 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-6" />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-3 leading-tight" data-id="element-7">
            Poné tu plata a trabajar
            <br data-id="element-8" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-9">
              las 24 horas del día
            </span>
          </h1>
          <p className="text-gray-400 text-base sm:text-lg max-w-xl mx-auto mt-4" data-id="element-10">
            InnovaTrading es un bot de copy trading automatizado con gestión de
            riesgo inteligente. Copiá las operaciones de traders profesionales
            sin hacer nada — el bot opera por vos.
          </p>
        </motion.div>

        {/* Video Section */}
        <motion.div className="mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-11">
          <h2 className="text-xl sm:text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-12">
            <PlayCircleIcon className="w-6 h-6 text-secondary" data-id="element-13" />
            Mirá este video para empezar
          </h2>
          <p className="text-gray-400 text-sm mb-4" data-id="element-14">
            Seguí cada paso del video para configurar tu cuenta y activar el
            bot.
          </p>

          <div className="rounded-2xl overflow-hidden border border-white/10 bg-navy-surface shadow-[0_0_40px_rgba(34,211,238,0.1)]" data-id="element-15">
            <div className="relative w-full pt-[56.25%]" data-id="element-16">
              <iframe className="absolute top-0 left-0 w-full h-full" src={CONFIG.videoUrl} title="Tutorial InnovaTrading" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-17" />
            </div>
          </div>

          {/* Instructional text */}
          <p className="mt-6 text-center text-secondary font-bold text-base sm:text-lg tracking-wide" data-id="element-18">
            ⬇️ Hacer todo paso a paso en el orden de abajo ⬇️
          </p>

          {/* Registration CTA */}
          <div className="mt-5 flex flex-col items-center gap-4" data-id="element-19">
            <a href="https://www.vantagemarkets.com/open-live-account/?affid=MjQwMDUwNTY=&invitecode=iCb2gDsP" target="_blank" rel="noopener noreferrer" className="w-full text-center px-6 py-4 rounded-2xl border border-white/10 bg-white/5 font-bold text-lg uppercase tracking-wide hover:bg-white/10 hover:border-white/20 hover:shadow-[0_0_25px_rgba(255,255,255,0.08)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-200" data-id="element-20">
              Registrate Ahora
            </a>
            <p className="text-secondary font-mono font-bold text-lg tracking-widest" data-id="element-21">
              🔑 Código de referido:{' '}
              <span className="text-white bg-white/10 px-3 py-1 rounded-lg" data-id="element-22">
                iCb2gDsP
              </span>
            </p>

            <a href="https://vantageapp.onelink.me/qaPD?af_xp=referral&pid=IBSHARE&deep_link_value=mt4id-192769%7Cplatform-copytrading&deep_link_sub1=spid-1103278&af_dp=com.vttech.VantageFX%3A%2F%2F&af_force_deeplink=true" target="_blank" rel="noopener noreferrer" className="w-full text-center px-6 py-4 rounded-2xl border border-white/10 bg-white/5 font-bold text-lg uppercase tracking-wide hover:bg-white/10 hover:border-white/20 hover:shadow-[0_0_25px_rgba(255,255,255,0.08)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-200" data-id="element-23">
              Afiliarse al Copy
            </a>
          </div>
        </motion.div>

        {/* WhatsApp CTA */}
        <motion.div className="mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-24">
          <h2 className="text-xl sm:text-2xl font-bold mb-2 text-center" data-id="element-25">
            Si tenés alguna duda, o querés acceder al grupo, enviá tus datos acá
          </h2>

          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 w-full px-6 py-5 rounded-2xl border border-white/10 bg-white/5 font-bold text-lg hover:bg-white/10 hover:border-white/20 hover:shadow-[0_0_25px_rgba(255,255,255,0.08)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-200" data-id="element-26">
            <MessageCircleIcon className="w-6 h-6" data-id="element-27" />
            Escribir a WhatsApp
          </a>
        </motion.div>

        {/* Disclaimer */}
        <motion.div className="mb-12" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.55
      }} data-id="element-28">
          <div className="flex gap-3 items-start bg-red-500/10 border border-red-500/20 rounded-xl p-4" data-id="element-29">
            <ShieldAlertIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-30" />
            <p className="text-sm text-red-300/90 leading-relaxed" data-id="element-31">
              <strong data-id="element-32">
                Si no seguís los pasos del video tal cual, no vas a poder tener
                acceso al bot.
              </strong>{' '}
              Es necesario completar cada paso correctamente para que podamos
              activar tu cuenta.
            </p>
          </div>
        </motion.div>

        {/* Footer */}
        <motion.footer className="border-t border-white/10 pt-6 text-center" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.65
      }} data-id="element-33">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-34">
            <img src={LOGO_URL} alt="InnovaTrading" className="w-7 h-7 rounded-lg object-cover border border-white/10" data-id="element-35" />
            <span className="font-bold text-sm" data-id="element-36">InnovaTrading</span>
          </div>
          <p className="text-xs text-gray-600 max-w-md mx-auto leading-relaxed" data-id="element-37">
            El trading conlleva riesgo. El rendimiento pasado no garantiza
            resultados futuros.
          </p>
          <p className="text-xs text-gray-700 mt-1" data-id="element-38">
            © {new Date().getFullYear()} InnovaTrading
          </p>
        </motion.footer>
      </main>
    </div>;
}